import React from "react";
import "./OvertimeTable.css";

const OvertimeTable = ({
  overtimeData,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
}) => {
  const isOverdue = (row) => Boolean(row.is_expired);

  const getStatusClassName = (status, row) => {
    if (!status) return "";
    if (isOverdue(row)) return "status-overdue";
    if (status === "Согласован") return "status-approved";
    if (status === "Не согласован") return "status-rejected";
    if (status === "На рассмотрении") return "status-pending";
    return "";
  };

  const getRowClassName = (row) => {
    if (isOverdue(row)) return "overtime-row--overdue";
    const reviewers = row.reviewers || [];
    if (!reviewers.length) return "";

    const statuses = reviewers.map((r) => r.status);
    const allApproved = statuses.every((status) => status === "Согласован");
    const anyRejected = statuses.some((status) => status === "Не согласован");

    if (allApproved) return "overtime-row--approved";
    if (anyRejected) return "overtime-row--rejected";
    return "";
  };

  const safeTotalPages = Math.max(1, totalPages || 1);
  const changePage = (nextPage) => {
    if (!onPageChange) return;
    onPageChange(Math.min(safeTotalPages, Math.max(1, nextPage)));
  };

  return (
    <div className="overtime-table-container">
      <h2 className="overtime-table-title">Мои переработки</h2>
      <div className="overtime-table-note">
        * Заявка на переработку рассматривается в течение 10 дней с момента
        подачи. По истечении этого срока заявка автоматически переходит в статус
        "Просрочено" и не может быть согласована.
      </div>
      <table className="overtime-table">
        <thead>
          <tr>
            <th>Дата</th>
            <th>Проект</th>
            <th>Часы</th>
            <th>Статус согласования</th>
            <th>Статус использования</th>
          </tr>
        </thead>
        <tbody>
          {overtimeData.map((row, index) => (
            <tr
              key={index}
              className={getRowClassName(row)}
            >
              <td>{row.date}</td>
              <td>{row.project}</td>
              <td>{row.hours}</td>
              <td>
                {isOverdue(row) ? (
                  <div className="status-overdue">Просрочено</div>
                ) : (
                  row.reviewers.map((reviewer, idx) => (
                    <div
                      key={idx}
                      className={getStatusClassName(reviewer.status, row)}
                    >
                      {reviewer.name}: {reviewer.status}
                    </div>
                  ))
                )}
              </td>
              <td>
                {row.is_used ? (
                  <div>
                    <div>Использован</div>
                    {row.date_of_use && (
                      <div style={{ fontSize: "0.9em", color: "#666" }}>
                        {row.date_of_use}
                      </div>
                    )}
                  </div>
                ) : row.is_partially_used && row.used_hours ? (
                  <div>
                    <div>Использовано частично</div>
                    <div style={{ fontSize: "0.9em", color: "#666" }}>
                      {row.used_hours} из {row.hours}
                    </div>
                    {row.days_left !== null && row.days_left !== undefined && (
                      <div style={{ fontSize: "0.9em", color: "#666" }}>
                        Осталось дней: {row.days_left}
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    <div>Не использован</div>
                    {row.days_left !== null && row.days_left !== undefined && (
                      <div style={{ fontSize: "0.9em", color: "#666" }}>
                        Осталось дней: {row.days_left}
                      </div>
                    )}
                    {row.expires_tomorrow && !row.is_expired && (
                      <div style={{ fontSize: "0.9em", color: "#d97706" }}>
                        Сгорит завтра
                      </div>
                    )}
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {safeTotalPages > 1 && (
        <div className="overtime-table-pagination">
          <button
            type="button"
            className="overtime-table-pagination__button"
            onClick={() => changePage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Назад
          </button>
          <div className="overtime-table-pagination__info">
            Страница {currentPage} из {safeTotalPages}
          </div>
          <button
            type="button"
            className="overtime-table-pagination__button"
            onClick={() => changePage(currentPage + 1)}
            disabled={currentPage === safeTotalPages}
          >
            Вперёд
          </button>
        </div>
      )}
    </div>
  );
};

export default OvertimeTable;
